import { Injectable } from '@angular/core';
import {
  StsConfigLoader,
  OpenIdConfiguration,
  LogLevel
} from 'angular-auth-oidc-client';
import { Observable, from } from 'rxjs';
import { map } from 'rxjs/operators';
import { ConfigService } from './config.service';

@Injectable()
export class CustomStsConfigLoader implements StsConfigLoader {
  constructor(private configService: ConfigService) {}
  loadConfigs(): Observable<OpenIdConfiguration[]> {
    // Convert the promise to an observable and return the config array
    return from(this.configService.loadConfig()).pipe(
      map(() => [{
        authority: 'https://login.microsoftonline.com/a9b3476e-d359-4708-9b96-8eddaff74210/v2.0',
        redirectUrl: this.configService.redirectUrl + '/app',
        postLogoutRedirectUri: this.configService.redirectUrl,
        clientId: 'f52f6177-37e7-4f10-8e78-9a5918f32edd',
        scope: 'openid offline_access api://f52f6177-37e7-4f10-8e78-9a5918f32edd/cbyd.customer',
        responseType: 'code',
        // startCheckSession: true,
        useRefreshToken: true,
        silentRenew: true,
        historyCleanupOff: true,
        ignoreNonceAfterRefresh: true,
        autoUserInfo: false,
        // silent_renew_url: 'https://nmpstoragedev.z6.web.core.windows.net/silent-renew.html',
        // silentRenewUrl: 'http://localhost:4200/silent-renew.html',
        disableIatOffsetValidation: true,
        maxIdTokenIatOffsetAllowedInSeconds: 60,
        logLevel: LogLevel.Error,
        renewTimeBeforeTokenExpiresInSeconds: 1000
        // all other properties you want to set
      }])
    );
  }
}
